import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Box } from '@mui/material';
import Grid from '@mui/material/Grid';
import ItemHeatMap from './ItemHeatMap';
import ItemBasicInfo from './ItemBasicInfo';
import ItemSummaryCards from './ItemSummaryCards';
import ItemOnHandInventory from './ItemOnHandInventory';
import ItemChannelBreakdown from './ItemChannelBreakdown';
import { useCommonStyles } from './styles';
import { EXCEL_ONHAND_INVENTORY } from '../../../constants/constant';
import analytics from '../../../helper/analytics';
import tracker from '../../../constants/tracker';
import WeekOfSupplyWrapper from '../../../common/components/charts/WeekOfSupply/WeekOfSupplyWrapper';
function Summary({
	weekFilter,
	category,
	selectedFilter,
	selectedTab,
	startDate,
	endDate,
	itemNum,
	itemName,
}) {
	const classes = useCommonStyles();
	const kpiName = useSelector((state) => state.salesReducer.kpiName);
	const props = {
		weekFilter,
		category,
		selectedFilter,
		itemNum,
		startDate,
		endDate,
		selectedTab,
		itemName,
	};
	useEffect(() => {
		const pageid = `${kpiName}Item${selectedTab}`
			.replaceAll(/\s/g, '')
			.toUpperCase();
		analytics.trackPageInfo(tracker.PAGE_ID[pageid]);
	}, []);
	return (
		<Box sx={{ flexGrow: 1 }}>
			<Grid container>
				{/* Basic info */}
				<Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
					<Box data-test-id="item-basic-info" className={classes.container}>
						<ItemBasicInfo {...props} />
					</Box>
				</Grid>
				{/* On Hand Inventory */}
				<Grid item xs={12} sm={6} md={6} lg={6} xl={4}>
					<Box
						data-test-id="on-hand-inventory"
						className={classes.container}
						style={{ paddingLeft: '8px' }}>
						<ItemOnHandInventory
							chartName={EXCEL_ONHAND_INVENTORY}
							{...props}
						/>
					</Box>
				</Grid>
				{/* Summary cards */}
				<Grid item xs={12} sm={12} md={12} lg={12} xl={4}>
					<Box data-test-id="summary-cards">
						<ItemSummaryCards {...props} />
					</Box>
				</Grid>
				{/* Heatmap */}
				<Grid item xs={12} sm={12} md={12} lg={8} xl={8}>
					<Box
						data-test-id="heatmap"
						className={classes.container}
						sx={{
							'@media only screen and (min-width: 780px)': {
								height: '546px !important',
							},
							'@media only screen and (max-width: 779px)': {
								height: '814px',
							},
						}}>
						<ItemHeatMap {...props} />
					</Box>
				</Grid>
				{/* Channel breakdown */}
				<Grid item xs={12} sm={12} md={12} lg={4} xl={4}>
					<Box
						data-test-id="channel-breakdown"
						className={classes.container}
						sx={{
							'@media only screen and (min-width: 780px)': {
								height: '546px !important',
							},
						}}>
						<ItemChannelBreakdown {...props} height={'546px'} />
					</Box>
				</Grid>
				{/* Week of supply - Store */}
				<Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
					<Box
						data-test-id="week-of-supply-store"
						className={classes.container}>
						<WeekOfSupplyWrapper
							wosType={'Store'}
							selectedTab={selectedTab}
							startDate={startDate}
							endDate={endDate}
							weekFilter={weekFilter}
							itemName={itemName}
							itemNum={itemNum}
						/>
					</Box>
				</Grid>
				{/* Week of supply - DC */}
				<Grid item xs={12} sm={6} md={6} lg={6} xl={6}>
					<Box data-test-id="week-of-supply-dc" className={classes.container}>
						<WeekOfSupplyWrapper
							wosType={'DC'}
							selectedTab={selectedTab}
							startDate={startDate}
							endDate={endDate}
							weekFilter={weekFilter}
							itemName={itemName}
							itemNum={itemNum}
						/>
					</Box>
				</Grid>
			</Grid>
		</Box>
	);
}
Summary.propTypes = {
	weekFilter: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	category: PropTypes.string,
	selectedFilter: PropTypes.string,
	selectedTab: PropTypes.string,
	startDate: PropTypes.string,
	endDate: PropTypes.string,
	itemNum: PropTypes.string,
	itemName: PropTypes.string,
};
export default Summary;
